import { constructEnum } from '@/lib/enum';

export default constructEnum('AccessLevel', {
  USER: 0,
  ADMIN: 1,
  SUPER_ADMIN: 2
});
